import { render, staticRenderFns } from "./antecipacao-desconto-repasse.vue?vue&type=template&id=c25703f4&scoped=true"
import script from "./antecipacao-desconto-repasse.vue?vue&type=script&lang=ts"
export * from "./antecipacao-desconto-repasse.vue?vue&type=script&lang=ts"
import style0 from "./antecipacao-desconto-repasse.vue?vue&type=style&index=0&id=c25703f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25703f4",
  null
  
)

export default component.exports